module.exports = __webpack_public_path__ + "img/tbx.a9812c07.svg";